import React, { useState, useContext } from 'react';

import FullName from './FullName';
import MobileNumber from './MobileNumber';
import EmailAddress from './EmailAddress';
import Password from './Password';
import Address from './Address';
import NationalInsuranceNumber from './NationalInsuranceNumber';
import MarketingPreference from './MarketingPreference';
import withFeatureFlags from '../FeatureFlags/withFeatureFlags';
import { customerDataContext } from '../../contexts/CustomerDataProvider';
import Loading from '../Loading/Loading';

/** @import {MyProfile} from './MyProfileTypes' */
/** @import {Customer, NewAccount} from '../../contexts/CustomerDataProviderTypes' */
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

import './myProfile.scss';

function MyProfile(/** @type {WithFeatureFlagsProps} */ { featureEnabled }) {
    var data = useContext(customerDataContext);
    var [mobileNumber, setMobileNumber] = useState(/** @type {string | null} */ (null));
    var [nationalInsuranceNumber, setNationalInsuranceNumber] = useState(/** @type {string | null} */ (null));

    /** @returns {any} */
    const safeCustomerGet = (/** @type {typeof data} */ customerData, /** @type {keyof Customer<NewAccount>} */ field) => {
        if (customerData && customerData.data && customerData.data.customer) {
            return customerData.data.customer[field];
        }

        return '';
    };

    /** @returns {any} */
    const safeAddressGet = (/** @type {typeof data} */ customerData) => {
        if (customerData && customerData.data && customerData.data.customer) {
            var address = customerData.data.customer.address
            return address ? address : {};
        }

        return {};
    };

    const updateMobile = (/** @type {{number: string}} */ data) => {
        setMobileNumber(data.number);
    };

    const updateNationalInsuranceNumber = (/** @type {{nationalInsuranceNumber: string}} */ data) => {
        setNationalInsuranceNumber(data.nationalInsuranceNumber);
    };

    // helper to check if customer has an account with product.productType === 'FIXED_RATE_CASH_ISA' test
    const hasFixedRateCashIsa = (/** @type {typeof data} */ customerData) => {
        if (!customerData || !customerData.data || !customerData.data.customer) return false;
        const accounts = customerData.data.customer.accounts || [];
        return accounts.some(acc => acc && acc.product && acc.product.productType === 'FIXED_RATE_CASH_ISA');
    };

    // flatNumber
    // buildingNumber
    // buildingName,
    // streetLine1
    // streetLine2
    // town
    // country
    // postCode

    /** @type {MyProfile} */
    const profile = {
        name: safeCustomerGet(data, "firstName"),
        middleName: safeCustomerGet(data, "middleName"),
        surname: safeCustomerGet(data, "lastName"),
        mobileNumber: mobileNumber ? mobileNumber : safeCustomerGet(data, "mobileNumber"),
        email: safeCustomerGet(data, "email"),
        nationalInsuranceNumber: nationalInsuranceNumber ? nationalInsuranceNumber : safeCustomerGet(data, "nationalInsuranceNumber"),
        address: {
            flatNumber: safeAddressGet(data).flatNumber,
            buildingName: safeAddressGet(data).buildingName,
            buildingNumber: safeAddressGet(data).buildingNumber,
            streetLine1: safeAddressGet(data).streetLine1,
            streetLine2: safeAddressGet(data).streetLine2,
            town: safeAddressGet(data).town,
            country: safeAddressGet(data).country || 'GBR',
            postCode: safeAddressGet(data).postCode,
            postalCode: ''
        },
        marketingPreference: {
            email: safeCustomerGet(data, "emailCommunication"),
            phone: safeCustomerGet(data, "smsCommunication"),
            onlineBankingMessaging: safeCustomerGet(data, "onlineBankingCommunication")
        }
    };

    if (!data || data.loading || !data.data) return <Loading message="We're loading your profile..." />;
    return (
        <div className="my-profile">
            <h1 className="my-profile__title">My profile</h1>
            <div className="my-profile__content">
                <FullName profile={profile} />
                <div className="my-profile__row">
                    <div className="my-profile__col">
                        <MobileNumber profile={profile} onSave={updateMobile} />
                    </div>
                    <div className="my-profile__col my-profile__doubleCol">
                        <EmailAddress profile={profile} />
                    </div>
                </div>

                <div className="my-profile__row">
                    <div className="my-profile__col">
                        <Password />
                    </div>
                    <div className="my-profile__col my-profile__address my-profile__doubleCol">
                        <Address profile={profile} />
                    </div>
                </div>
                {featureEnabled('EnableNationalInsuranceNumber') && (
                    <>
                        {hasFixedRateCashIsa(data) && (
                            <div className="my-profile__row">
                                <div className="my-profile__col">
                                </div>
                                <div className="my-profile__col my-profile__doubleCol">
                                    <NationalInsuranceNumber profile={profile} onSave={updateNationalInsuranceNumber}/>
                                </div>
                            </div>
                        )}
                    </>
                )}

                <MarketingPreference profile={profile}/>
            </div>
        </div>
    );
}

export default withFeatureFlags(MyProfile);
